import { createStyles, makeStyles } from '@material-ui/core'
import { GridCellParams, GridColDef, DataGrid, GridSortDirection, GridValueFormatterParams } from '@material-ui/data-grid'
import React from 'react'
import { useHistory } from 'react-router'
import { DataGridBoolean } from '../../../Components/DataGrid/DataGridBoolean'
import { ServiceSchema } from '../../../Schema/ServiceSchema'
import { formatLocalDateTime } from '../../../Utils/DateFunctions'
import { ServiceTag } from './ServiceTag'

const columns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Name',
    width: 250,
    renderCell: (params: GridValueFormatterParams) => {
      return (
        <ServiceTag serviceId={params.getValue(params.id, 'id')?.toString()} />
      )
    },
  },
  {
    field: 'notation',
    headerName: 'Notation',
    width: 200,
  },
  {
    field: 'minTransitDays',
    headerName: 'Min. Transit Days',
    width: 165,
    type: 'number',
  },
  {
    field: 'maxTransitDays',
    headerName: 'Max Transit Days',
    width: 165,
    type: 'number',
  },
  {
    field: 'courierEnabled',
    headerName: 'Courier?',
    width: 150,
    align: 'center',
    renderCell: (params: GridValueFormatterParams) => {
      return (
        <DataGridBoolean params={params} />
      )
    },
  },
  {
    field: 'courierDefault',
    headerName: 'Courier Default',
    width: 150,
    align: 'center',
  },
  {
    field: 'isEnabled',
    headerName: 'Enabled?',
    width: 120,
    align: 'center',
    renderCell: (params: GridValueFormatterParams) => {
      return (
        <DataGridBoolean params={params} />
      )
    },
  },
  {
    field: 'updated',
    headerName: 'Updated',
    width: 180,
    type: 'dateTime',
    valueFormatter: (params: GridValueFormatterParams) => {
      return formatLocalDateTime(params.getValue(params.id, 'updated') as Date)
    },
  },
  {
    field: 'created',
    headerName: 'Created',
    width: 180,
    type: 'dateTime',
    valueFormatter: (params: GridValueFormatterParams) => {
      return formatLocalDateTime(params.getValue(params.id, 'created') as Date)
    },
  },
]

interface ServicesDataGridProps {
  entities: ServiceSchema[]
}

export const ServicesDataGrid: React.FC<ServicesDataGridProps> = ({
  entities,
}) => {
  const history = useHistory()
  const styles = useStyles()

  const [sortModel, setSortModel] = React.useState([
    {
      field: 'name',
      sort: 'asc' as GridSortDirection,
    },
  ])

  const handleOnCellClick = (params: GridCellParams) => {
    /* if (_.includes(['status', 'assigneeId'], cellParams.field)) {
      return
    } */
    history.push(`/settings/services/${params.getValue(params.id, 'id')}`)
  }

  return (
    <DataGrid
      sortModel={sortModel}
      onSortModelChange={(model) => setSortModel(model)}
      className={styles.grid}
      columns={columns}
      rows={entities}
      showColumnRightBorder
      onCellClick={handleOnCellClick}
    />
  )
}

const useStyles = makeStyles(theme =>
  createStyles({
    grid: {
      fontSize: 14,
    },
  }),
)
